<template>
  <div>
    <v-row row>
      <v-col cols="12">
        <Parent />
      </v-col>
    </v-row>

    <v-divider class="pt-3"></v-divider>

    <v-row row>
      <v-col cols="12">
        <v-list dense>
          <v-list-item
            v-for="(item, index) in menuItems"
            :key="index"
            :to="item.route"
          >
            <v-list-item-avatar
              item
              size="32"
              :color="item.iconBackgroundColor"
              style="border-radius: 4px; justify-content: center"
            >
              <v-badge color="red" dot overlap v-if="item.alert">
                <v-icon color="white" style="font-size: 18px">
                  {{ item.icon }}
                </v-icon>
              </v-badge>
              <v-icon v-else color="white" style="font-size: 18px">
                {{item.icon }}
              </v-icon>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>

            <v-list-item-action>
              <v-btn icon ripple>
                <v-icon color="accent" size="16"
                  >fas fa-chevron-right</v-icon
                >
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-col>
    </v-row>

    <v-row row>
      <v-col cols="12">
        <v-card class="mt-2 mb-2" flat>
          <!-- <ChildrenList /> -->
        </v-card>
      </v-col>
    </v-row>

    <v-row row>
      <v-col cols="12" mt-5>
        <v-list>
          <v-list-item href="/logout" color="error">
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Parent from './Parent';
import ChildrenList from './ChildrenList';


export default {
  name: 'ProfileList',

  data() {
    return {};
  },
  components: {
    Parent,
    ChildrenList,
  },

  methods: {},

  computed: {
    ...mapGetters(['outstandingSubscriptionInvoices']),
    parent() {
      return this.$store.getters.parent;
    },

    menuItems() {
      return [
        // {
        //   title: 'Bookings',
        //   icon: 'fal fa-calendar-alt',
        //   iconBackgroundColor: 'alert',
        //   route: {
        //     name: 'Bookings'
        //   },
        //   alert: false
        // },
        // {
        //   title: 'Inbox',
        //   icon: 'fal fa-inbox',
        //   iconBackgroundColor: 'third',
        //   route: {
        //     name: 'Communications'
        //   },
        //   alert: false
        // },

        {
          title: 'Saved Cards',
          icon: 'fal fa-credit-card',
          iconBackgroundColor: 'secondary',
          route: {
            name: 'SavedCardsPage',
            params: {
              person: this.parent,
              personId: this.parent.personId,
            },
          },
          alert: false,
        },
        {
          title: 'My Monthly Payments',
          iconBackgroundColor: 'primary',
          icon: 'fal fa-redo',
          route: {
            name: 'Subscriptions',
          },
          alert: Object.values(this.outstandingSubscriptionInvoices).length > 0,
        },
      ];
    },
  },
  async mounted() {
    if (!'firstName' in this.parent) {
      await this.$store.dispatch('GET_PARENT');
    }
  },
  updated() {
  //  console.log('this.parent', this.parent);
  },
};
</script>

<style lang="scss">
.v-avatar--item {
  border-radius: 4px !important;
}

.v-badge__badge {
  height: 12px !important;
  width: 12px !important;
  right: -15px !important;
}
</style>
